import React from "react";

import {
  Header,
  Button,
  OrderTotal,
  PaymentInputFields,
  LoadingIcon,
  Captcha,
} from "../UI";
import { useTranslations, useFormValidation } from "tds_shared_ui";
import { AdditionalEmailsSection } from "./AdditionalEmailsSection";

export function PlaceOrderForm({
  variant = "checkout",
  onSubmit,
  className,
  checkoutSummary,
  formValues,
  onChange,
  readOnly,
  loading,
  paymentBlocked,
  onPaymentSuccess,
  onPaymentError,
  onValidationChange,
  onSubmitAvailable,
  onCancel,
  onBack,
  captchaRef,
  paymentContainerId,
}) {
  const { translate } = useTranslations(["common"]);

  const { formProps, getInputProps, showValidationErrors } = useFormValidation({
    submit: onSubmit,
    className,
  });

  const isKeycodes = variant === "keycodes";
  const containerClass = isKeycodes
    ? "keycode-confirmation row"
    : "checkout-place-order-form row";
  const paymentId =
    paymentContainerId || (isKeycodes ? "keycodes-payment" : "cart-payment");
  const mainHeader = isKeycodes
    ? translate("HEADER_ORDER_SUMMARY")
    : translate("HEADER_PLACE_ORDER");

  if (!checkoutSummary) {
    return <LoadingIcon display={true} size="3x" />;
  }

  return (
    <form {...formProps}>
      <div className={containerClass}>
        <div className="col">
          <div className="mb-3">
            <div className="border-bottom mb-3">
              <Header level={2}>{mainHeader}</Header>
            </div>

            <div className={isKeycodes ? "" : "mb-5"}>
              <OrderTotal className="basic" checkoutSummary={checkoutSummary} />
            </div>

            {checkoutSummary.ccRequired && (
              <div className="row">
                <div className="col-sm-6 mb-5">
                  {isKeycodes && (
                    <div className="border-bottom mb-3">
                      <Header level={2}>{translate("HEADER_PAYMENT")}</Header>
                    </div>
                  )}
                  <PaymentInputFields
                    id={paymentId}
                    grandTotalAmount={checkoutSummary.totalAmount}
                    orderId={checkoutSummary.orderNumber}
                    currencyCode={checkoutSummary.currencyCode}
                    paymentConfig={checkoutSummary.paymentConfig}
                    onPaymentSuccess={onPaymentSuccess}
                    onPaymentError={onPaymentError}
                    onValidationChange={onValidationChange}
                    onSubmitAvailable={onSubmitAvailable}
                  />
                </div>
              </div>
            )}

            <AdditionalEmailsSection
              formValues={formValues}
              onChange={onChange}
              readOnly={readOnly}
              getInputProps={getInputProps}
              showValidationErrors={showValidationErrors}
              translate={translate}
            />

            {captchaRef && (
              <div className="pb-5">
                <Captcha captchaRef={captchaRef} />
              </div>
            )}

            <div>
              <Button
                variant="outline-secondary"
                type="button"
                onClick={onCancel}
              >
                {translate("BUTTON_CANCEL")}
              </Button>

              <div className="float-right">
                <Button
                  variant="link"
                  type="button"
                  onClick={onBack}
                  disabled={loading}
                >
                  {translate("BUTTON_BACK")}
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={loading || paymentBlocked}
                >
                  <LoadingIcon display={loading} />
                  {translate("BUTTON_PLACE_ORDER")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}